<template>
  <div class="edit-module-edu-main">
    <div class="edit-editor-title">
      <div class="edit-back" @click="extrasBack">
        <i class="iconfont iconchevron-left"></i> 返回
      </div>
      <div class="edit-module-name" :class="[currentInfo.data && currentInfo.data.id ? 'pointer' : 'default']"
           @click="currentInfo.data && currentInfo.data.id && editModuleTitle()">
        <span class="text-overflow">{{title || cvDetail.submodule_info.extras_title}}</span>
        <i style="color: #C2C2C2;" class="pointer iconfont iconedit-" @click="editModuleTitle"></i>
      </div>
      <button class="edit-module-save" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存
      </button>
    </div>
    <div class="edit-editor-content">
      <el-form ref="editModuleEdu" :model="formData">
        <div v-for="(item, index) in extrasPosition" :key="index">
          <div class="position-r">
            <div class="edit-module-item-name margin-top-24"
                 @click="editListTitle(item.field, cvDetail.submodule_info[`${item.field}_title`])">
              {{cvDetail.submodule_info[`${item.field}_title`] || item.labelCn}}
              <!-- <i class="pointer iconfont iconedit-"></i> -->
            </div>
            <el-form-item class="position-r">
              <!--              <textarea class="extras-textarea" v-model="formData[item.field] && formData[item.field].description" @focus="showTagState(item.field)"-->
              <!--                        :placeholder="item.placeholderCn" name="" id=""></textarea>-->
			    <!-- 其他 技能 -->
				<select-skill v-if="item.field === 'skill'" :data="formData" :placeholder="item.placeholderCn" :separator="separator" @customFocus="showTagState(item.field)"/>
				<!-- 其他 -->
				<el-input v-else class="extras-textarea" v-model="formData[item.field] && formData[item.field].description"
						type="textarea" :autosize="{ minRows: 1, maxRows: 500 }" @focus="showTagState(item.field)"
						:placeholder="item.placeholderCn"/>
            </el-form-item>
            <suggest-card v-if="suggestInfo.suggest && suggestInfo.field === item.field"
                          @handleClose="handleClose"></suggest-card>
          </div>

					<!-- 专业技能 -->
          <template v-if="showTag.skill && item.field === 'skill'">
						<template v-if="cvProfessionSkills.length">
							<div class="tag-title">专业技能</div>
							<div class="tag-main">
								<div class="tag-menu" v-for="(val, index) in cvProfessionSkills" :key="index"
										@click="selectTag(item.field, val)" :class="{'active': val.checked}">
									{{val.value}}
								</div>
							</div>
						</template>
						<div class="tag-title">通用技能</div>
					</template>
					<div class="tag-main" v-if="tags[item.field].length && showTag[item.field]">
            <div class="tag-menu" v-for="(val, index) in tags[item.field]" :key="index"
                 @click="selectTag(item.field, val)" :class="{'active': val.checked}">
              {{val.value}}
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <cv-auxiliary>
      <div class="module-delete" slot="operation" @click="deleteModule" v-if="deleteIconShow">
        <i class="iconfont icontrash-"></i>
        <span>删除这段经历</span>
      </div>
    </cv-auxiliary>
    <!--    <div class="edit-editor-btn">-->
    <!--      <div>-->

    <!--      </div>-->
    <!--      <div class="btn-box">-->
    <!--        <button class="close-btn" @click="back">取消</button>-->
    <!--        <button class="complete-btn" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import api from '@/api'
	import rules from '@/assets/json/rules'
	import WFormData from '../../../../../components/editor/w-form-data'
	import cvAuxiliary from './cv-auxiliary'
	import suggestCard from '../../../../../components/editor/suggest-card'
	import { cvMixin } from '../../../../../assets/js/mixins'
	import tags from '../../../../../assets/json/editor-extras.json'
	import { otherForm } from '../../../../../assets/json/editor-module.json'
	import { setEditNumLocalStorage, debounce } from '@/assets/js/util'
	import selectSkill from '@/views/editorResume/cvsEditor/components/select/selectSkill'

	export default {
		name: 'editModelOther',
		mixins: [ cvMixin ],
		data () {
			return {
				separator: null, // 分隔符 中文简历 ，英文简历 ,
				debounceSave: null,
				isSave: false,
				title: '', // 模块标题，只在修改标题后使用
				oldFormData: {},
				constData: {
					// is_sub_item: true, // 是否合并经历
					// lang: ''
				},
				showTag: {
					skill: false,
					language: false,
					certificate: false,
					other: false,
					interest: false,
				},
				formData: {
					skill: {
						name: '技能',
						en_default_name: 'Skills',
						description: null
					},
					language: {
						name: '语言',
						en_default_name: 'Languages',
						description: null
					},
					certificate: {
						name: '证书/执照',
						en_default_name: 'Certifications',
						description: null
					},
					other: {
						name: '活动',
						en_default_name: 'Activities',
						description: null
					},
					interest: {
						name: '兴趣',
						en_default_name: 'Interests',
						description: null
					}
				},
				cvProfessionSkills:[], //简历匹配的技能tag
			}
		},
		computed: {
			...mapState('editor', [ 'cvToken', 'cvDetail', 'currentInfo', 'backUpInfo', 'extras', 'suggestInfo', 'checkCloseEditModule' ]),
			...mapState('experience', [ 'experienceList' ]),
			...mapState('cvs', [ 'cv', 'editorCvToken', 'highlightShow' ]),
			// other 模块的排序
			extrasPosition () {
				let { submodule_info: { extras_position } } = this.cvDetail
				if (extras_position && extras_position.length) {
					let extras = []
					let position = extras_position.map(item => item.slice(0, -1))
					otherForm.forEach(item => {
						const index = position.findIndex(value => value === item.field)
						extras[index] = item
					})
					return extras
				} else {
					return otherForm
				}
			},
			// 选择tag的列表
			tags () {
				let newTags = JSON.parse(JSON.stringify(tags))
				return newTags
			},
			// 是否显示删除按钮
			deleteIconShow () {
				return this.currentInfo.operation === 'edit'
			},
			// 当前编辑的经历库
			currentExperience () {
				return this.experienceList.extras
			}
		},
		components: {
			WFormData,
			suggestCard,
			cvAuxiliary,
			selectSkill
		},
		created () {
			this.debounceSave = debounce(this.save, 300)
			// 初始化分隔符
			this.separator = this.cvDetail.basic_info.lang === 'cn' ? '，' : ','
			// 获取技能 tag
			this.getCvProfessionSkills();
		},
		watch: {
			checkCloseEditModule: function (state) {
				if (state) {
					this.extrasBack()
					//设置是否需要取消当前编辑状态，并返回
					setTimeout(() => {
						this.setCheckCloseEditModule(false)
					}, 10)
				}
			}
		},
		mounted () {
			this.initFormData()
		},
		methods: {
			...mapActions('cvsEditor', [ 'editExtra' ]),
			...mapActions('editor', [ 'createExtra', 'updateExtra', 'createCvDetail', 'updateCvDetail' ]),
			...mapMutations('editor', [ 'setExtrasData', 'setSuggestInfo', 'setCheckCloseEditModule' ]),
			...mapMutations('experience', [ 'updateExperienceModule', 'deleteExperienceOtherSelect', 'updateExperienceTitleName', 'updateExperienceOtherModule' ]),
			...mapActions('manage', [ 'getMenuList' ]),
			showTagState (field) {
				this.showTag[field] = true
			},
			// 选择标签
			selectTag (field, tag) {
				tag.checked = !tag.checked
				this.formData[field].description = this.formData[field].description || ''
				if (tag.checked) {
					// 值为空时，添加tag不需要添加分隔符，有值时，添加tag需要加分隔符
					// let str = this.formData[field].description ? (this.separator + tag.value) : tag.value
					this.formData[field].description += (tag.value + this.separator)
				} else {
					// 优先匹配有分隔符的tag，如果没有，则直接匹配tag
					let str = this.formData[field].description.includes(tag.value + this.separator) ? (tag.value + this.separator) : tag.value
					this.formData[field].description = this.formData[field].description.replace(new RegExp(str, 'gi'), '')
				}
				this.$forceUpdate()
			},
			// 关闭优化建议卡片
			handleClose () {
				this.setSuggestInfo({})
			},
			getRulesTitle (title, check) {
				for (let i = 0; i < rules.rules.length; i++) {
					if (rules.rules[i].name === title || (check && check.name === rules.rules[i].name)) {
						return rules.rules[i].title
					}
				}
				return '提示'
			},
			// 初始化表单数据
			initFormData () {
				let { operation } = this.currentInfo
				if (operation === 'edit') {
					for (let key in this.extras) {
						this.extras[key] = { ...this.formData[key], ...this.extras[key] }
					}
				}
				this.formData = this.extras
				// let extras = JSON.parse(JSON.stringify(this.extras))
				// for (let key in extras) {
				// 	if (extras[key].description) {
				// 		this.formData[key] = extras[key]
				// 	}
				// }
			},

			// 对比当前和经历库中所选的other是否有更改
			verifyExtrasChange () {
				let diffExtras = {}
				for (let key in this.formData) {
					if (this.formData[key].id) {
						const k = `${ key }s`
						const index = this.currentExperience[k].findIndex(val => val.id === this.formData[key].id)
						if (index > -1 && this.currentExperience[k][index].description !== this.formData[key].description) {
							diffExtras[key] = this.formData[key]
						}
					}
				}
				if (Object.keys(diffExtras).length) {
					return diffExtras
				}
			},

			// 清理末尾的分隔符
			clearLastSeparator () {
				let props = null
				let desc = null
				let lastValue = null
				for (props in this.formData) {
					desc = this.formData[props].description
					lastValue = desc && desc.substr(desc.length - 1, 1)
					if (lastValue === this.separator) {
						this.formData[props].description = desc.slice(0, desc.length - 1)
					}
				}
			},

			// 保存
			async save () {
				// if (this.isSave) return
				// this.isSave = true
				setEditNumLocalStorage()
				this.clearLastSeparator()
				let diffExtras = this.verifyExtrasChange()
				if (diffExtras) {
					let data = await this.verifyExtra(diffExtras)
					if (data && data.length) {
						const alertData = {
							...this.alertData,
							messageTitle: '修改同步提示',
							confirmButtonText: '同步',
							cancelButtonText: '不同步',
							messageContent: `<p>此段经历在其他简历中被引用，</p><p style="color: #FF453E">是否同步修改到其他简历？</p>`,
							confirm: async close => {
								this.experienceChange()
								close()
							},
							cancel: close => {
								this.experienceChange(data)
								close()
							},
						}
						this.setAlertData(alertData)
					} else {
						this.experienceChange()
					}
				} else {
					this.experienceChange()
				}
			},
			// 创建和更新extras内容
			async experienceChange (data) {
				let { submodule_info, basic_info } = this.cvDetail
				let createRes = {}
				let updateRes = {}
				let createPayload = {
					section_lang: basic_info.lang
				}
				let updatePayload = {
					section_lang: basic_info.lang
				}
				for (let key in this.formData) {
					if (this.formData[key].description) {
						if (!this.formData[key].id || this.formData[key].kind === 'sample' || (data && data.includes(key))) {
							createPayload[key] = this.formData[key]
						} else {
							updatePayload[key] = this.formData[key]
						}
					}
				}
				//创建
				//  && !window.location.href.includes('mentor')
				if (createPayload && Object.keys(createPayload).length > 1) {
					let res = await this.createExtra(createPayload)
					if (res.code === 1000) {
						// this.isSave = false
						this.dealExtrasData(res.data.others)
					} else if (res.code === 80143) {
						// this.isSave = false
						// 显示超出模块最大限制
						this.showModuleMaxTips()
					}
				}
				//更新
				if (updatePayload && Object.keys(updatePayload).length > 1) {
					let res = await this.updateExtra(updatePayload)
					if (res.code === 1000) {
						// this.isSave = false
						this.dealExtrasData(res.data.others)
					} else {
						// this.isSave = false
					}
				}
				this.cvDetailChange()
			},
			// 更新或者创建简历
			async cvDetailChange () {
				let { basic_info, submodule_info } = this.cvDetail
				let subModuleInfo = JSON.parse(JSON.stringify(submodule_info))
				const isCreate = basic_info.kind === 'template' || basic_info.kind === 'sample'
				const moduleIndex = subModuleInfo.sections_position.findIndex(item => item.type === 'extras')
				let payload = {
					operation_type: isCreate ? '' : 'update_submodule_info',
					submodule_info: {}
				}
				if (moduleIndex === -1) {
					subModuleInfo.sections_position = [ ...subModuleInfo.sections_position, {
						id: null,
						type: 'extras',
						info_ids: []
					} ]
				}
				for (let key in this.extras) {
					subModuleInfo[`${ key }_id`] = this.extras[key] && this.extras[key].description ? this.extras[key].id : null
				}
				// if (window.location.href.includes('mentor')) {
				// 	let res = await this.updateCvDetail({ operation_type: 'touch' })
				// 	this.resetEditState()
				// } else
				if (isCreate) {
					let basic_info = { ...this.cvDetail.basic_info }
					let res = await this.createCvDetail({
						payload: {
							basic_info,
							submodule_info: subModuleInfo,
							format_info: this.cvDetail.format_info,
							operation_type: ''
						}
					})
					//整理模块管理模块选中状态
					this.getMenuList()
					// 重置vuex模块信息
					this.resetEditState()
				} else {
					payload.submodule_info = subModuleInfo
					await this.updateCvDetail(payload)
					//整理模块管理模块选中状态
					this.getMenuList()
					// 重置vuex模块信息
					this.resetEditState()
					this.setDealCheck(true)
					if (this.saveFormDataByDialog) {
						this.saveFormDataByDialog()
						this.setFormDataFn(null)
						// commit('setFormDataFn', null)
					}
				}
			},
			// 更新或者创建extras数据之后改变store里面的值
			dealExtrasData (infos) {
				let { operation, title } = this.currentInfo
				let extras = JSON.parse(JSON.stringify(this.extras))
				for (let key in infos) {
					if (infos[key].id) extras[key] = infos[key]
				}
				//更新cvs简历数据
				this.setExtrasData(extras)
				//更新经历库某个模块数据-other
				this.updateExperienceOtherModule({
					operation,
					title,
					data: infos
				})
			},
			// 判断extra里面有无被其他简历引用的内容
			async verifyExtra (diffExtras) {
				let payload = {}
				for (let key in diffExtras) {
					if (diffExtras[key].id) {
						payload[`${ key }_id`] = diffExtras[key].id
					}
				}
				let res = await api.cvsEditor.verifyExtra(payload)
				if (res.code === 80144) {
					return res.data.imported_arr
				} else if (res.code === 1000) {
					return []
				} else {
					this.$message.error(res.message)
        }
			},
			// 删除模块
			async deleteModule () {
				const alertData = {
					...this.alertData,
					messageContent: `
          <p>删除后可以在页面右下角「经历库」内找回</p>
          <p style="color: #FF453E">确定删除本段经历吗?</p>
        `,
					confirm: async close => {
						let { submodule_info, basic_info } = this.cvDetail
						let { type, data } = this.currentInfo
						let payload = {
							operation_type: 'update_submodule_info',
							submodule_info: {
								skill_id: null,
								language_id: null,
								certificate_id: null,
								other_id: null,
								interest_id: null,
								// sections_position: sections_position.filter(item => item.type !== 'extras')
							}
						}
						if(basic_info.kind == 'sample' || basic_info.kind == 'template') {
              this.$message.error('请先编辑简历信息')
              return ;
            }
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('删除成功')
							//清除经历库选中状态
							this.deleteExperienceOtherSelect({ type, data })

							this.setExtrasData({})
							this.resetEditState()
							//删除经历库某个模块选中状态
						} else {
							this.$message.error(res.message)
						}
					},
					cancel: close => {
						close()
					},
				}
				this.setAlertData(alertData)
			},
			// 修改模块标题
			async editModuleTitle () {
				let { submodule_info } = this.cvDetail
				if (this.currentInfo.operation !== 'edit') {
					this.$message.error('请先保存模块')
					return false
				}
				const alertData = {
					...this.alertData,
					messageTitle: '修改模块名称',
					inputData: {
						show: true,
						length: 15,
						value: submodule_info.extras_title,
						showLength: true,
						placeholder: '请输入模块名称'
					},
					cancel: close => {
						close()
					},
					confirm: async (close, value) => {
						let payload = {
							submodule_info: {
								extras_title: value,
							},
							operation_type: 'update_submodule_info',
							not_need_default_error_tips: true
						}
						let { type } = this.currentInfo
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('修改成功')
							//更新经历库模块名称
							this.updateExperienceTitleName({ type, title: value })
							//整理模块管理模块选中状态
							this.getMenuList()
						} else {
							let errorMsg = res.message
							if (payload.not_need_default_error_tips && res.code === 80120) { // 未找到对应简历
								errorMsg = '请编辑简历后再修改'
							}
							this.$message.error(errorMsg)
						}
					}
				}
				this.setAlertData(alertData)
			},
			// 修改小模块标题
			async editListTitle (type, title) {
				console.log("small title")
				let { submodule_info } = this.cvDetail
				if (this.currentInfo.operation !== 'edit') {
					this.$message.error('请先保存模块')
					return false
				}
				const alertData = {
					...this.alertData,
					messageTitle: '修改模块名称',
					inputData: {
						show: true,
						length: 15,
						value: title,
						showLength: true,
						placeholder: '请输入模块名称'
					},
					cancel: close => {
						close()
					},
					confirm: async (close, value) => {
						if (value.trim().length === 0) {
								this.$message.error('名称不能为空')
							return
						}
						let payload = {
							submodule_info: {
								[`${ type }_title`]: value,
							},
							operation_type: 'update_submodule_info',
							not_need_default_error_tips: true
						}
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('修改成功')
						} else {
							let errorMsg = res.message
							if (payload.not_need_default_error_tips && res.code === 80120) { // 未找到对应简历
								errorMsg = '请编辑简历后再修改'
							}
							this.$message.error(errorMsg)
						}
					}
				}
				this.setAlertData(alertData)
			},
			//显示超出模块最大限制
			showModuleMaxTips () {
				console.log(this.alertData)
				const alertData = {
					...this.alertData,
					messageTitle: '创建失败',
					showCancelButton: false,
					confirmButtonText: '我知道了',
					messageContent: `当前模块下经历数量已达到上限，请打开右侧边栏「经历库」点击「管理」按钮，删除多余经历`,
					confirm: async close => {
						close()
					},
					cancel: close => {
						close()
					},
				}
				this.setAlertData(alertData)
			},
			// 获取技能 tag
			getCvProfessionSkills(){
				api.cvs.getCvProfessionSkills(this.cvToken).then(res=>{
					if(res.code === 1000){
						this.cvProfessionSkills = res.data.map(value => {
							return { value }
						})
					}
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
  .edit-module-edu-main {
    padding: 0 28px;
    .edu-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edu-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        cursor: pointer;
        .edu-item-select {
          width: 16px;
          height: 16px;
          border: 1px solid #DEDFE1;
          margin-right: 12px;
          text-align: center;
          line-height: 16px;
          &.active {
            .iconfont {
              font-size: 14px;
              margin: auto;
            }
          }
        }
        .iconfont {
          margin-right: 8px;
        }
      }
    }
    .edit-module-item-name {
      cursor: pointer;
      .iconfont {
        margin-left: 5px;
      }
    }
    .extras-textarea {
      width: 100%;
      min-height: 16px;
      max-height: 120px;
      ::v-deep textarea {
        resize: none;
      }
    }
		.tag-title{
			color: #9c9c9c;
    	margin-top: 28px;
		}
    .tag-main {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 4px;
      .tag-menu {
        height: 26px;
        border: 1px solid #ECECEC;
        border-radius: 14px;
        line-height: 26px;
        text-align: center;
        padding: 0 12px;
        font-size: 14px;
        color: #9C9C9C;
        margin-top: 16px;
        margin-right: 12px;
        cursor: pointer;
        &.active {
          border-color: #ff6644;
          background: #ff6644;
          color: #fff;
        }
      }
    }
    .edit-module-name {
      span {
        display: inline-block;
        max-width: 80%;
      }
      i {
        margin-left: 6px;
      }
    }
  }

  ::v-deep .el-textarea__inner {
	min-height: 40px !important;
    line-height: 2 !important;
  }
</style>
